<template>
  <div>
    <DxPopup
      id="attach-file-popup"
      :title="$t('Searcher.observations.attach_file_title')"
      :visible.sync="popupShow"
      :show-close-button="true"
      :on-hidden="onHidden"
      :close-on-outside-click="false"
      height="auto"
      :width="700"
    >
      <DxForm :show-colon-after-label="false">
        <DxGroupItem>
          <DxSimpleItem
            :data-field="$t('Searcher.observations.description')"
            editor-type="dxTextArea"
            :editor-options="{
              value: fileDescription,
              onValueChanged: onChangeDescription,
              placeholder: $t('Searcher.observations.description'),
              maxLength: 256,
              height: 85
            }"
          >
            <DxRequiredRule :message="$t('DxRegisterCampania_end_date_require')" />
          </DxSimpleItem>
          <DxSimpleItem
            :data-field="$t('Searcher.observations.attach_file')"
            template="attachFile"
          />
        </DxGroupItem>
        <template #attachFile>
          <div class="fileuploader-container">
            <attachAFile
              :pop-up-is-visible="popupShow"
              @setExtension="setExtensionData"
            />
          </div>
        </template>
      </DxForm>

      <f7-block-footer
        class="content-action-botton"
      >
        <f7-button
          class="dx-btn-save"
          raised
          styling-mode="outlined"
          name="ButtonSave"
          @click="savePopup"
        >
          {{ $t('Button_save_text') }}
        </f7-button>
      </f7-block-footer>
    </DxPopup>
    <f7-button
      class="dx-btn-file"
      raised
      type="default"
      styling-mode="outlined"
      @click="openPopup"
    >
      <f7-icon
        md="f7:arrow_up_doc"
        class="color-black"
      />
    </f7-button>
  </div>
</template>

<script>

import { DxPopup } from 'devextreme-vue/popup';
import moment from 'moment';

import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,

} from 'devextreme-vue/form';
import { mapActions, mapState } from 'vuex';
import attachAFile from './attachAFile.vue';

export default {
  name: 'AttachFilePopup',
  components: {
    DxPopup,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
    attachAFile,
  },
  data() {
    return {
      popupShow: false,
      extension: '',
      fileUploaded: [],
    };
  },
  computed: {
    ...mapState('SearcherObservations', ['file', 'fileDescription']),
  },
  methods: {
    setExtensionData(value) {
      this.extension = value;
    },
    openPopup() {
      this.popupShow = true;
    },
    onHidden() {
      this.extension = 0;
      this.fileUploaded = [];
      this.setFile('');
      this.setFileDescription('');
    },
    savePopup() {
      if (this.fileDescription !== '' && this.file) {
        this.addMultimedia({
          tempName: moment().format('DDMMYYYY_HHmmss'),
          description: this.fileDescription,
          attachment: this.file,
          extension: this.extension,
        });
        this.popupShow = false;
      } else {
        this.$f7.dialog.alert(this.$t('Fields_Required'));
      }
    },
    onChangeDescription(e) {
      this.setFileDescription(e.value);
    },

    ...mapActions('SearcherObservations', ['addMultimedia', 'setFile', 'setFileDescription']),

  },
};
</script>
<style lang="scss" scoped>
@import './AttachFilePopup.styles.scss';
</style>
